module.exports = __webpack_public_path__ + "img/laboratorio.16eb260e.svg";